"use strict";

const OutfallInventoryModalController = function () {
  const hardAssetPagesByOutfallPage = {
    "outfall-set-location": "hard-asset-set-location",
    "outfall-general-info": "hard-asset-general-info",
  };

  async function invokeOutfallInventoryModal(maybeId, startingPage) {
    return HardAssetInventoryModalController.invokeHardAssetInventoryModal(
      maybeId,
      "outfall",
      hardAssetPagesByOutfallPage[startingPage],
    );
  }

  return {
    invokeOutfallInventoryModal,
  };
};

module.exports = OutfallInventoryModalController();

const HardAssetInventoryModalController = require("../muni/hardAssetInventoryModalController");
